/**
 * Create Advanced Filter Price Range Term web component.
 * Use this component to render Advanced Advanced Filter Price Range Term element
 */
class SHTAdvancedFilterPriceRange extends HTMLElement {
  constructor() {
    super();
    this.elms = {
      input_elms: this.querySelectorAll(`[data-type="price-range"]`),
      lte_elm: this.querySelector(`[data-type-price="lte"]`),
      gte_elm: this.querySelector(`[data-type-price="gte"]`),
    };

    this.bindEventHandlers();
    this.setMinAndMaxValues();
  }
  /**
   * bind event handler to web component elements
   */
  bindEventHandlers() {
    this.elms.input_elms.forEach((element) =>
      element.addEventListener("change", this.onRangeChangeHandle.bind(this))
    );
  }
  /**
   * Handle the range change event
   * @param Event event
   */
  onRangeChangeHandle(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }
  /**
   * Set min/max attribute
   */
  setMinAndMaxValues() {
    let gte = this.elms.gte_elm;
    let lte = this.elms.lte_elm;

    if (lte.value) gte.setAttribute("max", lte.value);
    if (gte.value) lte.setAttribute("min", gte.value);
    if (gte.value === "") lte.setAttribute("min", 0);
    if (lte.value === "") gte.setAttribute("max", lte.getAttribute("max"));
  }
  /**
   * Adjust to valid the input
   */
  adjustToValidValues(input) {
    let value = Number(input.value);
    let min = Number(input.getAttribute("min"));
    let max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
  /**
   * Set value to gte and lte
   * @param number gte
   * @param number lte
   */
  setValues(gte, lte) {
    this.elms.gte_elm.value = gte;
    this.elms.lte_elm.value = lte;
  }
}
// Register to the Browser from `customElements` API
customElements.define(
  "sht-advanced-filter-price-range",
  SHTAdvancedFilterPriceRange
);
